export const PREFIX = 'mediavine-video'
export const PREFIX_PLAYLIST = 'mediavine-playlist'
export const PREFIX_WRAPPER = 'mediavine-wrapper'

export const TITLE_BAR_HEIGHT = '30px'
export const AD_REPORTER_HEIGHT = '36px'

export const PIP_BODY = `${PREFIX}__has-sticky`
export const BODY_WRAPPER_INSERTED = `${PREFIX}-inserted`
export const BODY_HOISTED = `${PREFIX}-hoisted`

export const DISABLED = `${PREFIX}__disabled`
export const ENABLED = `${PREFIX}__enabled`
export const HIDDEN = `${PREFIX}__hidden`
export const MOBILE = `${PREFIX}__mobile`
export const PIP = `${PREFIX}__pip`
export const THEME_DARK = `${PREFIX}__dark-theme`
export const THEME_LIGHT = `${PREFIX}__light-theme`

export const AD_REPORTER = `${PREFIX}__ad-reporter`
export const AD_REPORTER_BTN = `${AD_REPORTER}__btn`
export const AD_REPORTER_LOGO = `${AD_REPORTER}__logo`
export const DIALOG = `${PREFIX}__dialog`
export const DIALOG_END = `${DIALOG}__end`
export const DIALOG_END_REPLAY = `${DIALOG_END}__replay`
export const DIALOG_END_YOUTUBE = `${DIALOG_END}__youtube`
export const DIALOG_UPNEXT = `${DIALOG}__upnext`
export const DIALOG_UPNEXT_COUNTDOWN = `${DIALOG_UPNEXT}__countdown`
export const DIALOG_UPNEXT_COUNTDOWN_ACTION = `${DIALOG_UPNEXT}__countdown__action`

export const DIALOG_UPNEXT_COUNTDOWN_REPLAY = `${DIALOG_UPNEXT}__countdown__replay`
export const DIALOG_UPNEXT_COUNTDOWN_REMAINING = `${DIALOG_UPNEXT}__countdown__remaining`
export const DIALOG_UPNEXT_THUMBNAIL = `${DIALOG_UPNEXT}__thumbnail`
export const DIALOG_UPNEXT_THUMBNAIL_PLAY = `${DIALOG_UPNEXT}__thumbnail__play`
export const DIALOG_UPNEXT_HEADER = `${DIALOG_UPNEXT}__header`
export const DIALOG_UPNEXT_SUBTITLE = `${DIALOG_UPNEXT}__subtitle`
export const DIALOG_UPNEXT_TITLE = `${DIALOG_UPNEXT}__title`
export const DIALOG_UPNEXT_YOUTUBE = `${DIALOG_UPNEXT}__youtube`
export const PLACEMENT_CONTAINER = `${PREFIX}__placement-container`
export const ROOT_CONTAINER = `${PREFIX}__root-container`
export const TARGET_DIV = `${PREFIX}__target-div`
export const TITLE_BAR = `${PREFIX}__title-bar`
export const TITLE_BAR_CLOSE_BTN = `${TITLE_BAR}__close-btn`
export const TITLE_BAR_NAME = `${TITLE_BAR}__name`
export const TITLE_BAR_PERMALINK = `${TITLE_BAR}__permalink`
export const VIDEO_CONTAINER = `${PREFIX}__video-container`
export const PLAYER = `${PREFIX}__player`
export const SKIP_AD_BTN = `${PREFIX}__skip-ad-btn`
export const YOUTUBE_BTN = `${PREFIX}__youtube-btn`
export const YOUTUBE_BTN_CONTAINER = `${PREFIX}__youtube-btn-container`

export enum PopoutPlacement {
  bottomCenter = 'bottom_center',
  bottomLeft = 'bottom_left',
  bottomRight = 'bottom_right',
  topCenter = 'top_center',
  topLeft = 'top_left',
  topRight = 'top_right'
}
